import { useRef } from 'react';
import styles from './styles.module.css';
import { IconLeft, IconRight } from '@americanexpress/dls-icons';
import { useBreakpoint } from '../../styleless/breakpoint';
import { useScrollPosition } from '../../../utilities/useScrollPosition';
import cn from 'classnames';

export function HorizontalScrollContainer({
  children,
  className: customClasses,
  hideControlsOnSm,
  leftButtonProps = {},
  rightButtonProps = {},
  ...rest
}: React.ComponentPropsWithoutRef<'section'> & {
  hideControlsOnSm?: boolean;
  leftButtonProps?: React.ComponentProps<'button'>;
  rightButtonProps?: React.ComponentProps<'button'>;
}) {
  const { sm } = useBreakpoint();
  const ref = useRef<HTMLDivElement>(null);
  const { scrollPosition, handleScroll } = useScrollPosition(ref);

  function handleClickLeft() {
    if (!ref.current) return;
    ref.current.scrollBy(-ref.current.clientWidth, 0);
  }
  function handleClickRight() {
    if (!ref.current) return;
    ref.current.scrollBy(ref.current.clientWidth, 0);
  }

  return (
    <section className={cn(styles.wrapper, customClasses)} {...rest}>
      <div ref={ref} className={styles.carousel} onScroll={handleScroll}>
        {children}
      </div>
      <button
        aria-label="Scroll to previous items"
        {...leftButtonProps}
        onClick={(e) => {
          handleClickLeft();
          leftButtonProps.onClick?.(e);
        }}
        className={cn(
          styles.arrowBtn,
          styles.arrowLeft,
          leftButtonProps.className
        )}
        hidden={
          scrollPosition === 'none' ||
          scrollPosition === 'start' ||
          (sm && hideControlsOnSm)
        }
      >
        <IconLeft size="md" />
      </button>
      <button
        aria-label="Scroll to next items"
        {...rightButtonProps}
        onClick={(e) => {
          handleClickRight();
          rightButtonProps.onClick?.(e);
        }}
        className={cn(
          styles.arrowBtn,
          styles.arrowRight,
          rightButtonProps.className
        )}
        hidden={
          scrollPosition === 'none' ||
          scrollPosition === 'end' ||
          (sm && hideControlsOnSm)
        }
      >
        <IconRight size="md" />
      </button>
    </section>
  );
}
